import { SENTRY_NAME as NAME, SENTRY_DISPLAY_NAME as DISPLAY_NAME } from '../Destinations';

const DIR_NAME = 'Sentry';

const DISPLAY_NAME_TO_DIR_NAME_MAP = { [DISPLAY_NAME]: DIR_NAME };
const CNameMapping = {
  [NAME]: NAME,
  sentry: NAME,
  Sentry: NAME,
};

export { NAME, CNameMapping, DISPLAY_NAME_TO_DIR_NAME_MAP, DISPLAY_NAME, DIR_NAME };
